import axios from "axios";
import { baseurl } from "../constants";

export const RedeemCoupon = async (coupon_id, coupon_code) => {
  try {
    const response = await axios.post(
      `${baseurl}/api/user/almond/coupancardcreate`,
      { coupon_id, coupon_code },
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return response;
  } catch (err) {
    return err.message;
  }
};
